import { isTablet } from '../../utils/mediaQueries'
;(function () {
  'use strict'

  const transformHeroTitleForDisplay = (title, nonBreakingText = '') => {
    if (!title) {
      return ''
    }

    if (!nonBreakingText) {
      return title
    }

    return title.replace(
      new RegExp(`(?<!\\p{L})(?:${nonBreakingText})(?!\\p{L})`, 'giu'),
      '<span style="white-space: nowrap;">$&</span>',
    )
  }

  function manageResizeListener(callback) {
    window.addEventListener('resize', callback)
    document.addEventListener('beforeunload', () => {
      window.removeEventListener('resize', callback)
    })
  }

  function onDocumentReady() {
    const heroSlider = document.querySelector('.cmp-hero-slider')

    if (heroSlider) {
      const slides = heroSlider.querySelectorAll('.cmp-hero-slider__slide')
      const actions = heroSlider.querySelector('.cmp-hero-slider__actions')
      const actionButtons = heroSlider.querySelector('.cmp-hero-slider__buttons')
      const progressBars = heroSlider.querySelectorAll('.cmp-hero-slider__progress-bar')
      const nextButton = heroSlider.querySelector('.cmp-hero-slider__button.next')
      const previousButton = heroSlider.querySelector('.cmp-hero-slider__button.previous')

      // This is being used in Header v1 to apply specific styles when a hero slider is present on the page
      // TODO: Remove this class and all related styles once Header v1 is removed
      document.body.classList.add('page-has-hero-slider')

      // Transform all hero titles
      const heroTitles = heroSlider.querySelectorAll('.cmp-hero-slider__content-title')
      for (const title of heroTitles) {
        const originalText = title.textContent
        const nonBreakingText = title.getAttribute('data-non-breaking-text')?.trim() || ''
        const transformedText = transformHeroTitleForDisplay(originalText, nonBreakingText)
        if (transformedText !== originalText) {
          title.innerHTML = transformedText
        }
      }

      const updateHeroTopPadding = () => {
        const header = document.querySelector('.cmp-header-v2') || document.querySelector('.cmp-header')
        const noBreadcrumbs = document.querySelector('.cmp-container--no-breadcrumbs')

        if (!header) {
          return
        }

        if (isTablet() && noBreadcrumbs) {
          const headerHeight = header.offsetHeight || 0
          const heroSliderCurrentBottomPadding = parseInt(window.getComputedStyle(heroSlider).paddingBottom) || 0
          const headerBottomPadding = parseInt(window.getComputedStyle(header).paddingBottom) || 0
          heroSlider.style.paddingTop = `${headerHeight + heroSliderCurrentBottomPadding - headerBottomPadding}px`
          return
        }

        if (heroSlider.style.paddingTop != null) {
          heroSlider.style.paddingTop = null
        }
      }

      if (slides.length === 1) {
        updateHeroTopPadding()
        manageResizeListener(updateHeroTopPadding)

        if (actions) actions.classList.add('cmp-hero-slider__actions--hidden')
        slides[0].classList.add('cmp-hero-slider__slide--is-active')
        return
      }

      let activeIndex = 0

      const updateSlides = (index) => {
        let currentIndex = 0
        for (const slide of slides) {
          slide.classList.toggle('cmp-hero-slider__slide--is-active', currentIndex === index)
          currentIndex++
        }
      }

      const updateProgressBars = (index) => {
        let currentIndex = 0
        for (const bar of progressBars) {
          const isActive = currentIndex === index
          bar.classList.toggle('cmp-hero-slider__progress-bar--is-active', isActive)
          if (isActive) {
            bar.setAttribute('aria-current', 'true')
          } else {
            bar.removeAttribute('aria-current')
          }
          currentIndex++
        }
      }

      const updateSlider = (index) => {
        updateSlides(index)
        updateProgressBars(index)
        announceSlideChange(index)
      }

      // slide content announcement
      const announceSlideChange = (index) => {
        const announcement = document.getElementById('hero-slider-announcement')
        if (!announcement) return

        const activeSlide = slides[index]
        if (!activeSlide) return

        const pretitle = activeSlide.querySelector('.cmp-hero-slider__content-pretitle')?.textContent?.trim() || ''
        const title = activeSlide.querySelector('.cmp-hero-slider__content-title')?.textContent?.trim() || ''
        const description =
          activeSlide.querySelector('.cmp-hero-slider__content-description')?.textContent?.trim() || ''

        const parts = [pretitle, title, description].filter(Boolean)
        const message = parts.length > 0 ? parts.join('. ') : `Slide ${index + 1}`

        announcement.textContent = message
      }

      const setupProgressBarListeners = () => {
        for (const [index, bar] of progressBars.entries()) {
          bar.addEventListener('click', () => {
            activeIndex = index
            updateSlider(activeIndex)
          })
        }
      }

      nextButton.addEventListener('click', () => {
        activeIndex = (activeIndex + 1) % slides.length
        updateSlider(activeIndex)
      })

      previousButton.addEventListener('click', () => {
        activeIndex = (activeIndex - 1 + slides.length) % slides.length
        updateSlider(activeIndex)
      })

      window.requestAnimationFrame(updateHeroTopPadding)

      setupProgressBarListeners()
      updateSlider(activeIndex)

      manageResizeListener(updateHeroTopPadding)
    }
  }

  if (document.readyState !== 'loading') {
    onDocumentReady()
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady)
  }
})()
